module.exports = __webpack_public_path__ + "img/689.1aaeb606.jpg";